module.exports = __webpack_public_path__ + "static/tat-24-a5f9eecf678ff0d3531f52629c7ae173.jpg";